import { FC } from "react";
import { FooterLinks } from "./FooterLinks";
import { FOOTER_LINKS } from "./constants";
import { Logo } from "../Logo";

interface Props {
  isShown?: boolean;
}
export const Footer: FC<Props> = ({ isShown = true }) => {
  if (!isShown) return null;

  return (
    <footer className="bg-purple-lighter">
      <div className="container flex justify-between gap-5 pb-20 pt-10 gl:py-10">
        <Logo isColored className="hidden sm:block" />

        <FooterLinks links={FOOTER_LINKS.MAIN_LINKS} />
        <FooterLinks links={FOOTER_LINKS.INFO_LINKS} />
      </div>
    </footer>
  );
};
